export default {
  setOpenMesh (context, payload) {
    return new Promise((resolve, reject) => {
      context.commit("setOpenMesh", payload)
      resolve()
    })
  }
}
